import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Scope, SeverityLevel } from '@sentry/browser';

@Injectable()
export class DagjeuitErrorHandler extends ErrorHandler {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override handleError(err: any): void {
    if (typeof Sentry !== 'undefined') {
      try {
        if (err instanceof HttpErrorResponse) {
          Sentry.withScope((scope: Scope) => {
            scope.setExtras({
              error: err.error,
              status: err.status,
              statusText: err.statusText,
              url: err.url,
            });
            Sentry.captureMessage(err.message, 'error' as SeverityLevel);
          });
        } else if (err instanceof Error) {
          Sentry.captureException(err);
        } else {
          Sentry.captureMessage(JSON.stringify(err), 'error' as SeverityLevel);
        }
      } catch (e) {
        super.handleError(e);
      }
    }
    if (typeof DD_LOGS !== 'undefined') {
      try {
        if (err instanceof HttpErrorResponse) {
          DD_LOGS.logger.error(err.message, {
            error: err.error,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          });
        } else if (err instanceof Error) {
          DD_LOGS.logger.error('Dagjeuit Error', {}, err);
        } else {
          DD_LOGS.logger.error(JSON.stringify(err), {});
        }
      } catch (e) {
        super.handleError(e);
      }
    }
    if (typeof DD_RUM !== 'undefined') {
      try {
        if (err instanceof HttpErrorResponse) {
          DD_RUM.addError(err.message, {
            error: err.error,
            status: err.status,
            statusText: err.statusText,
            url: err.url,
          });
        } else if (err instanceof Error) {
          DD_RUM.addError(err);
        } else {
          DD_RUM.addError(new Error(JSON.stringify(err)));
        }
      } catch (e) {
        super.handleError(e);
      }
    }
    if (
      typeof Sentry === 'undefined' &&
      typeof DD_LOGS === 'undefined' &&
      typeof DD_RUM === 'undefined'
    ) {
      super.handleError(err);
    }
  }
}
